import { InlineNotification, Modal } from '@carbon/react';
import { useAtom } from 'jotai';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { updateStructureGridAtom } from '../atoms';
import styles from './delete-structure-grid.module.scss';

interface DeleteStructureGridModalProps {
  isOpen: boolean;
  onClose: () => void;
  gridSurface: string;
  structureGridId: number;
}

export const DeleteStructureGridModal: React.FC<
  DeleteStructureGridModalProps
> = ({ isOpen, onClose, gridSurface, structureGridId }) => {
  const [deleteError, setDeleteError] = useState<string | null>(null);
  const [deleteState, deleteStructureGrid] = useAtom(updateStructureGridAtom);
  const history = useHistory();

  const handleDelete = () => {
    deleteStructureGrid({
      url: `/structure_grids/${structureGridId}`,
      type: 'DELETE',
      data: null,
      onSuccess: () => {
        history.push('/structure_grids');
        onClose();
      },
      onError: (error) => {
        setDeleteError(
          (error as { message: string })?.message ||
            'Error deleting structure grid'
        );
      },
    });
  };

  const handleClose = () => {
    if (!deleteState.loading) {
      setDeleteError(null);
      onClose();
    }
  };

  return (
    <Modal
      open={isOpen}
      onRequestClose={handleClose}
      modalHeading="Delete Grid"
      primaryButtonText="Delete"
      secondaryButtonText="Cancel"
      onRequestSubmit={handleDelete}
      onSecondarySubmit={handleClose}
      primaryButtonDisabled={deleteState.loading}
      preventCloseOnClickOutside={deleteState.loading}
      className={styles.deleteModal}
      size="sm"
      danger
    >
      <div className={styles.deleteModalContent}>
        {deleteError && <InlineNotification kind="error" title={deleteError} />}
        <p>
          Deleting Structure Grid <strong>{gridSurface}</strong>
        </p>
        <span>
          Are you sure you want to delete this structure grid? This action
          cannot be undone.
        </span>
      </div>
    </Modal>
  );
};
